import { Box, Typography, useTheme, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import CancelIcon from "@mui/icons-material/Cancel";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import EditIcon from "@mui/icons-material/Edit";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Header from "../Dashboard/Header";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
const PREFERENCE_KEY = "infiniteAppUserPreferences";

//Function for Validate enter Password
const validatePassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  if (
    password === "*" ||
    (password.length >= minLength &&
      hasUpperCase &&
      hasLowerCase &&
      hasSpecialChar)
  ) {
    return true;
  } else {
    return false;
  }
};

const getCurrentTimestamp = () => {
  return new Date().toISOString().slice(0, 19).replace("T", " ");
};

const Users = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [Users, setUsers] = useState([]);
  const token = localStorage.getItem("token");
  const colors = tokens(theme.palette.mode);

  //function and states for manage Password visibility =================
  const [showPassword, setShowPassword] = useState(true);
  const [showConPassword, setShowConPassword] = useState(true);
  const [showEditPassword, setEditShowPassword] = useState(true);
  const [showEditConPassword, setEditShowConPassword] = useState(true);
  const [pageSize, setPageSize] = useState(20);

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 28, // Reduced from 40 to 28
        fontFamily: "Source Sans Pro",
        fontSize: 13, // Reduced from 16 to 13
        tableAlign: "center",
      };
  // console.log(preferences);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleShowConfPassword = () => {
    setShowConPassword((prev) => !prev);
  };

  const handleClickEditShowPassword = () => {
    setEditShowPassword((prev) => !prev);
  };

  const handleShowEditConfPassword = () => {
    setEditShowConPassword((prev) => !prev);
  };

  useEffect(() => {
    fetchData();
  }, []);

  //Function to fetch cmp list and User List ==========================================
  const fetchData = async () => {
    if (!token) {
      navigate("/Auth/");
      return;
    }
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/userAPI/list",
        {},
        {
          headers: { Authorization: token },
        }
      );

      const UserListData = Object.values(response.data.users);
      // console.log("user list", UserListData);
      setUsers(UserListData);
    } catch (error) {
      console.log("Something went wrong ");
    }
  };

  //Function and state  to manage user creation procress ==================================

  const [userRole, setuserRole] = useState("");
  const [userEmail, setuserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cmpassword, setcmPassword] = useState("");
  const [userName, setuserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(null);
  const [open, setOpen] = useState(false);

  //function to open and close add user Popups
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setShowPassword(true);
    setShowConPassword(true);
  };

  //function for Add User
  const AddNewUser = async (e) => {
    e.preventDefault();
    setLoading(true);

    const valid = validatePassword(password);
    setIsValid(valid);

    if (!valid) {
      return;
    }

    if (!userName || !userEmail || !password || !userRole) {
      alert("All fields are required.");
      return;
    }

    if (password !== cmpassword) {
      alert("Passwords do not match.");
      return;
    }
    const created_At = getCurrentTimestamp();

    //API call for user creation
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/userAPI/create",
        {
          userName,
          userEmail,
          password,
          created_At,
          userRole,
        },
        {
          headers: { Authorization: token },
        }
      );

      if (response.data.exists) {
        alert(response.data.message);
        window.location.reload();
      } else {
        alert(response.data.message);
        setuserEmail("");
        setuserName("");
        setPassword("");
        setuserRole("");
        setcmPassword("");
        setOpen(false);
        navigate("/Infinite/Users");
      }
    } catch (error) {
      alert(
        `Error during registration: ${
          error.response?.data?.message || error.message
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  //==function for update User ================================================
  const [openEdit, setEditOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [name, setName] = useState("");
  const [UpPassword, setUpPassword] = useState("*");
  const [CmPassword, setCmPassword] = useState("*");
  const [Role, setRole] = useState("");
  const [isActive, setIsActive] = useState("");
  const [isEditValid, setIsEditValid] = useState(true);

  const handleEditUpdate = (user) => {
    setSelectedUser(user);
    setName(user.userName);
    setIsActive(user.isActive === 1 ? "Active" : "InActive");
    setRole(user.Role);
    setEditOpen(true);
    setUpPassword(user.target.value || "");
    setCmPassword(user.target.value || "");
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setSelectedUser(null);
  };

  //function to update User
  const handleEditSubmit = async (e) => {
    e.preventDefault();

    const valid = validatePassword(UpPassword);
    setIsEditValid(valid);
    if (!valid) {
      return;
    }

    if (!name || !UpPassword || !CmPassword) {
      alert("Please fill in all fields.");
      return;
    }
    if (UpPassword !== CmPassword) {
      alert("Passwords do not match...");
      return;
    }
    try {
      const updatedUser = {
        userId: selectedUser.id,
        userName: name,
        password: UpPassword,
        isActive: isActive === "Active" ? 1 : 0,
        userRole: Role,
        updated_at: getCurrentTimestamp(),
      };
      await axios.post(
        process.env.REACT_APP_API_URL + `/userAPI/update`,
        updatedUser,
        {
          headers: { Authorization: token },
        }
      );
      fetchData();
      alert("User updated successfully.");
      handleEditClose();
      window.location.reload();
    } catch (error) {
      alert("An error occurred while updating the user. Please try again.");
    }
  };

  //Function for Delete User
  const handleEditDelete = async () => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (!confirmation) {
      return;
    }

    try {
      await axios.post(
        process.env.REACT_APP_API_URL + `/userAPI/delete/`,
        { userId: selectedUser.id },
        {
          headers: { Authorization: token },
        }
      );
      alert("User deleted successfully");
      handleEditClose();
      window.location.reload();
    } catch (error) {
      alert("An error occurred while deleting the user");
    }
  };

  // ======================================

  //Table Row and colums
  const userListRow = Users.map((user) => ({
    id: user.user_Id,
    userName: user.user_Name,
    Email: user.user_Email,
    Role: user.user_Role,
    isStatus: user.user_active === 1 ? "Active" : "InActive",
  }));

  const getColumnWidth = (userListRow, field, header) => {
    const maxLength = Math.max(
      ...userListRow.map((r) => (r[field] ? r[field].toString().length : 0)),
      header.length
    );
    return maxLength * 10 + 20;
  };

  const columns = [
    {
      field: "Sr No",
      headerName: "Sr No",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(userListRow, "Sr No", "Sr No"),
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => params.api.getRowIndex(params.id) + 1,
    },

    {
      field: "userName",
      headerName: "Name",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(userListRow, "userName", "Name"),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "Email",
      headerName: "Email Id",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(userListRow, "Email", "Email Id"),
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "Role",
      headerName: "Role",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(userListRow, "Role", "Role"),
      sortable: false,
      disableColumnMenu: true,
    },
    // {
    //   field: "isStatus",
    //   headerName: "Status",
    //   headerAlign: preferences.tableAlign,
    //   align: preferences.tableAlign,
    //   width: getColumnWidth(userListRow, "isStatus", "Status"),
    //   sortable: false,
    //   disableColumnMenu: true,
    // },
    {
      field: "Action",
      headerName: "Action",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
              height: 20,
              "&:hover": {
                backgroundColor: colors.blueAccent[700],
                color: colors.primary[150],
              },
            }}
            startIcon={<EditIcon fontSize="small" />} // smaller icon
            type="button"
            onClick={() => handleEditUpdate(params.row)}
          >
            Edit
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <>
      {/* ==add new user popup window============================================ */}
      <Box>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            sx: {
              width: "350px",
              maxWidth: "80%",
              height: "485px",
            },
          }}
        >
          <DialogTitle
            sx={{
              fontSize: "24px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "15px",
              padding: "0 16px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <PersonAddAltIcon
                sx={{ marginRight: "8px", height: "50px", width: "30px" }}
              />
              Add New User
            </Box>
            <CancelIcon
              sx={{
                height: "50px",
                width: "30px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
          </DialogTitle>
          <DialogContent>
            <Typography variant="subtitle">
              Please fill out the form below:
            </Typography>
            <Box
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                marginTop: "10px",
              }}
            >
              <TextField
                size="small"
                autoFocus
                margin="dense"
                label="Name"
                type="text"
                name="name"
                fullWidth
                variant="outlined"
                value={userName}
                onChange={(e) => setuserName(e.target.value)}
                // disabled={loading}
                required
              />
              <TextField
                size="small"
                margin="dense"
                label="Email"
                type="email"
                name="email"
                fullWidth
                variant="outlined"
                value={userEmail}
                onChange={(e) => setuserEmail(e.target.value)}
                //  disabled={loading}
                required
              />

              <InputLabel>Role</InputLabel>
              <Select
                size="small"
                value={userRole}
                onChange={(e) => setuserRole(e.target.value)}
                // disabled={loading}
                required
              >
                <MenuItem value="">Select a Role</MenuItem>
                <MenuItem value="1">Owner</MenuItem>
                <MenuItem value="2">User</MenuItem>
              </Select>
              <TextField
                variant="outlined"
                size="small"
                margin="dense"
                label="Password"
                type={showPassword ? "password" : "text"}
                fullWidth
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={isValid === false}
                helperText={
                  isValid === false
                    ? "Password at least 8 characters, including uppercase, lowercase, and special characters."
                    : ""
                }
                sx={{
                  "& .MuiInputBase-root": {
                    color:
                      isValid === null ? "black" : isValid ? "green" : "red",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor:
                        isValid === null ? "black" : isValid ? "green" : "red",
                    },
                    "&:hover fieldset": {
                      borderColor:
                        isValid === null
                          ? "#357AE8"
                          : isValid
                          ? "green"
                          : "red",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor:
                        isValid === null
                          ? "#357AE8"
                          : isValid
                          ? "green"
                          : "red",
                    },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                size="small"
                margin="dense"
                label="Confirm Password"
                type={showConPassword ? "password" : "text"}
                name="Password"
                fullWidth
                variant="outlined"
                value={cmpassword}
                onChange={(e) => setcmPassword(e.target.value)}
                // disabled={loading}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleShowConfPassword}
                        edge="end"
                      >
                        {showConPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={cmpassword && password !== cmpassword}
                helperText={
                  cmpassword && password !== cmpassword
                    ? "Passwords do not match."
                    : ""
                }
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "80%",
                mr: 3.5,
                mb: 2,
              }}
            >
              <Button
                type="submit"
                onClick={AddNewUser}
                variant="contained"
                fullWidth
                sx={{
                  borderRadius: "10px",
                  backgroundColor: colors.blueAccent[700],
                  color: colors.primary[150],
                  "&:hover": {
                    backgroundColor: colors.blueAccent[700],
                    color: colors.primary[150],
                  },
                }}
              >
                Submit
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>

      {/* ======================= open popup for user Edit ================= */}
      <Box sx={{ p: 2 }}>
        <Dialog
          open={openEdit}
          onClose={handleEditClose}
          PaperProps={{
            sx: {
              display: "flex",
              width: "300px",
              height: "480px",
              maxHeight: "100%",
              maxWidth: "100%",
              alignItems: "center",
              justifyContent: "center",
            },
          }}
        >
          <DialogTitle>
            <Typography>Update User Information</Typography>
            <CancelIcon
              sx={{
                position: "absolute",
                top: "10px",
                right: "10px",
                height: "30px",
                width: "30px",
                cursor: "pointer",
              }}
              onClick={handleEditClose}
            />
          </DialogTitle>

          <DialogContent>
            <form>
              <TextField
                size="small"
                label="Name"
                variant="outlined"
                fullWidth
                margin="normal"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <InputLabel>Role</InputLabel>
              <Select
                size="small"
                value={Role}
                onChange={(e) => setRole(e.target.value)}
                fullWidth
                margin="normal"
                required
              >
                <MenuItem value="" disabled>
                  Select User Role
                </MenuItem>
                <MenuItem value="1">Owner</MenuItem>
                <MenuItem value="2">User</MenuItem>
              </Select>

              <InputLabel>Is Active</InputLabel>
              <Select
                size="small"
                value={isActive}
                onChange={(e) => setIsActive(e.target.value)}
                fullWidth
                margin="normal"
                required
              >
                <MenuItem value="" disabled>
                  Select User Is Active
                </MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="InActive">In Active</MenuItem>
              </Select>

              <TextField
                size="small"
                label="Password"
                type={showEditPassword ? "password" : "text"}
                variant="outlined"
                fullWidth
                margin="normal"
                value={UpPassword}
                onChange={(e) => setUpPassword(e.target.value)}
                required
                error={isEditValid === false}
                helperText={
                  isEditValid === false
                    ? "Password must be at least 8 characters, including uppercase, lowercase, and special characters."
                    : ""
                }
                sx={{
                  // Using the sx prop for inline styles
                  "& .MuiInputBase-root": {
                    color:
                      isEditValid === null
                        ? "black"
                        : isEditValid
                        ? "green"
                        : "red", // Text color
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor:
                        isEditValid === null
                          ? "black"
                          : isEditValid
                          ? "green"
                          : "red",
                    },
                    "&:hover fieldset": {
                      borderColor:
                        isEditValid === null
                          ? "#357AE8"
                          : isEditValid
                          ? "green"
                          : "red",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor:
                        isEditValid === null
                          ? "#357AE8"
                          : isEditValid
                          ? "green"
                          : "red",
                    },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickEditShowPassword}
                        edge="end"
                      >
                        {showEditPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                size="small"
                label="Confirm Password"
                variant="outlined"
                fullWidth
                margin="normal"
                value={CmPassword}
                onChange={(e) => setCmPassword(e.target.value)}
                type={showEditConPassword ? "password" : "text"}
                required
                error={CmPassword && UpPassword !== CmPassword}
                helperText={
                  CmPassword && UpPassword !== CmPassword
                    ? "Passwords do not match."
                    : ""
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleShowEditConfPassword}
                        edge="end"
                      >
                        {showEditConPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 2,
                  gap: 1,
                }}
              >
                <Button
                  size="small"
                  variant="contained"
                  color="success"
                  onClick={handleEditSubmit}
                >
                  Update
                </Button>
                <Button
                  size="small"
                  type="submit"
                  variant="contained"
                  color="error"
                  onClick={handleEditDelete}
                >
                  Delete
                </Button>
              </Box>
            </form>
          </DialogContent>
        </Dialog>
      </Box>

      {/* ================= show user list ================================== */}

      <Box mt="68px" ml="0px" mr="20px">
        <Box
          mb={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Header title="Users" />
          {/* Button positioned on the right */}
          <Button
            variant="contained"
            style={{
              height: "25px",
              minHeight: "25px",
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150], // Custom text color
              "&:hover": {
                backgroundColor: colors.blueAccent[700], // Maintain the same background on hover
                color: colors.primary[150], // Maintain the same text color on hover
              },
            }}
            startIcon={<PersonAddAltRoundedIcon />}
            size="small"
            onClick={handleClickOpen}
          >
            Add User
          </Button>
        </Box>
        <Box
          height="80vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
              color: colors.primary[120],
              cursor: "default",
            },
            "& .MuiDataGrid-columnHeader:focus": {
              outline: "none",
              boxShadow: "none",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              outline: "none",
              boxShadow: "none",
            },
            "& .MuiDataGrid-columnHeader:focus-visible": {
              outline: "none",
              boxShadow: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
            },

            // ✅ Zoom on hover using a class
            "& .UserLzoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          <DataGrid
            rows={userListRow}
            columns={columns}
            disableColumnSort={true}
            pageSize={pageSize}
            getRowClassName={() => "UserLzoom-row"}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            rowHeight={preferences.rowHeight} // Use the preference value
            headerHeight={30} // Reduced from 40 to 35
            componentsProps={{
              footer: {
                sx: {
                  height: 30, // Reduced from 40 to 35
                  minHeight: 30, // Reduced from 40 to 35
                },
              },
            }}
          />
        </Box>
      </Box>
    </>
  );
};
export default Users;
